import { BlockContainer } from "./styled";
import { renderContent } from "./message-types/message-content-render";
import { ServerMessageInfoProps } from "./types";
import { cn } from "@/lib/utils";

interface Props extends Pick<
  ServerMessageInfoProps,
  | "message"
  | "name"
  | "type"
  | "story"
  | "attachments"
  | "messageId"
  | "originalMessage"
  | "conversationId"
> {
  isLeft: boolean;
  isCurrentSMUMessage: boolean;
  isReplyToSMUMessage: boolean;
}

export const ReplyToBlock = ({
  message,
  name,
  type,
  story,
  attachments,
  isLeft,
  isCurrentSMUMessage,
  isReplyToSMUMessage,
  messageId,
  originalMessage,
  conversationId,
}: Props): JSX.Element => {
  return (
    <div className={cn("flex flex-col", isLeft ? "items-start" : "items-end")}>
      <span className="inline-block mx-4 italic pt-1 pb-1 text-ink-muted text-xs">
        {resolveRepliedMessageHeader(isCurrentSMUMessage, isReplyToSMUMessage)}
      </span>
      <BlockContainer>
        {renderContent({
          type,
          name,
          story,
          attachments,
          message,
          isTeamMessage: false,
          isLeft,
          isRepliedMessage: true,
          reactions: undefined,
          messageId,
          onReactionsChange: undefined,
          originalMessage,
          conversationId,
          conversation: undefined,
          accountContext: undefined,
        })}
      </BlockContainer>
    </div>
  );
};

function resolveRepliedMessageHeader(
  isCurrentSMUMessage: boolean,
  isReplyToSMUMessage: boolean
): string {
  if (isCurrentSMUMessage) {
    if (isReplyToSMUMessage) {
      return "Replied to themselves";
    }
    return "Replied to you";
  }

  if (isReplyToSMUMessage) {
    return "You replied";
  }

  return "You replied to yourself";
}
